<template>

  <v-card
      class="mx-auto"
      outlined
  >
    <v-col cols="12">
      <div class="headline mb-5 mt-5">Aplicaciones o Módulos</div>
      <v-divider></v-divider>

      <v-container class="mt-5">
        <v-row class="text-center" v-if="Object.keys(sistemas).length === 0">
          <v-col cols="12">
            Ninguna aplicación asignada
          </v-col>
        </v-row>

        <v-row v-else>

          <v-col cols="12" md="6" v-for="(item, index) in items" :key="index" :hidden="can(item.can)">
            <v-card outlined shaped class="pa-2">
              <v-list-item link :href="item.link + `${usuario.id}/${token_id}`">
                <v-list-item-avatar tile size="50px">
                  <v-avatar :color="item.color">
                    <v-icon dark>{{ item.icon }}</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.subtitle }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-btn icon>
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item>
            </v-card>
          </v-col>

        </v-row>

      </v-container>
    </v-col>
  </v-card>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: 'Home',
  data: () => ({
    items: [],
  }),
  created(){
    this.items = [
      /*{
        title: 'Maya',
        subtitle: 'Sistema para el Início de Trámites',
        color: 'red',
        icon: 'mdi-folder',
        can: 'Maya',
        link: `${this.url_modulo}:3600/login/`
      },
      {
        title: 'Trámites',
        subtitle: 'Sistema para la Gestión de Trámites',
        color: 'green',
        icon: 'mdi-file-document',
        can: 'Trámites',
        link: `${this.url_modulo}:3601/login/`
      },
      {
        title: 'Mantenimiento - Producciòn',
        subtitle: 'Sistema para la unidad de Mantenimiento',
        color: 'cyan darken-3',
        icon: 'mdi-tools',
        can: 'Mantenimiento',
        link: `${this.url_modulo}:3602/login/`
      },
      {
        title: 'Catastro',
        subtitle: 'Sistema para la administración de la unidad de catastro',
        color: 'brown',
        icon: 'mdi-map-marker-radius',
        can: 'Catastro',
        link: `${this.url_modulo}:3603/login/`
      },
      {
        title: 'Lecturas',
        subtitle: 'Sistema de Lecturas',
        color: 'pink darken',
        icon: 'mdi-calendar',
        can: 'Lecturas',
        link: `${this.url_modulo}:4005/login/`
      },
      {
        title: 'Recursos Humanos',
        subtitle: 'Sistema para la Administración del Personal',
        color: 'teal',
        icon: 'mdi-account-hard-hat',
        can: 'RRHH',
        link: `${this.url_modulo}:4000`
      },
      {
        title: 'Facturación',
        subtitle: 'Sistema de Facturación',
        color: 'amber',
        icon: 'mdi-open-in-new',
        can: 'Facturación',
        link: `${this.url_modulo}:4000`
      },
*/
      {
        title: 'COBRANZA - CAJAS',
        subtitle: 'Sistema de administración de cajas',
        color: 'blue-grey darken-1',
        icon: 'mdi-account-cash',
        can: 'Cobranzawebselasis',
        link: `https://cobranza.selaoruro.com/login/`

      },
/*
      {
        title: 'SISTEMA DE LECTURAS YakuSeLA',
        subtitle: 'Sistema de lecturas YakuSeLA - SeLAsis',
        color: 'pink darken',
        icon: 'mdi-monitor-cellphone',
        can: 'Lecturaselasis',
        link: `${this.url_modulo}:3606/#/login/`
      },
      {
        title: 'FACTURACION - IMPUESTOS',
        subtitle: 'Sistema de administración de Facturacion',
        color: 'pink darken',
        icon: 'mdi-open-in-new',
        can: 'Impuestoselasis',
        link: `${this.url_modulo}:3608/login/`

      },
      {
        title: 'CREDITOS - CISTERNAS',
        subtitle: 'Sistema de administración de Creditos',
        color: 'indigo darken-1',
        icon: 'mdi-cash-multiple',
        can: 'Creditos',
        link: `${this.url_modulo}:3609/login/`
      },
      {
        title: 'LABORATORIO',
        subtitle: 'Sistema de administración de Laboratorio',
        color: 'blue darken-1',
        icon: 'mdi-cash-multiple',
        can: 'Laboratorio',
        link: `${this.url_modulo}:3610/login/`
      },
      {
        title: 'CORTES',
        subtitle: 'Sistema de cortes',
        color: 'orange darken-1',
        icon: 'mdi-open-in-new',
        can: 'Cortes',
        link: `${this.url_modulo}:3611/login/`
      },
      {
        title: 'ALMACEN',
        subtitle: 'Sistema de almacen',
        color: '#8798EA',
        icon: 'mdi-book',
        can: 'Almacen',
        link: `${this.url_modulo}:3612/login/`
      },*/
      {
        title: 'ELECTROMECANICA',
        subtitle: 'Sistema de electromecanica',
        color: 'red grey-1',
        icon: 'mdi-wrench',
        can: 'Electromecanica',
        link: `https://electromecanica.selaoruro.com/login/`
      },
	{
        title: 'PEDIDOS',
        subtitle: 'Pedidos',
        color: 'grey grey-1',
        icon: 'mdi-book',
        can: 'Pedidos',
        link: `https://pedido.selaoruro.com/login/`
      },/*

	 {
        title: 'RECURSOS HUMANOS',
        subtitle: 'Sistema de recursos humanos',
        color: 'blue blue-1',
        icon: 'mdi-account-hard-hat',
        can: 'Recursoshumanos',
        link: `${this.url_modulo}:3615/login/`
      },*/


    ];
  },
  methods: {
    can(modulo) {
      return Object.values(this.sistemas).find(x => x === modulo) === undefined;
    }
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapState(['url_base', 'url_modulo', 'token', 'token_id', 'usuario', 'sistemas'])
  }
}
</script>
